// extracted by mini-css-extract-plugin
module.exports = {"container":"Account_container__3AvUE","body":"Account_body__3i88V","box":"Account_box__3gsjW","header":"Account_header__trx4J","wrapheader":"Account_wrapheader__1X8p-"};